import { render, staticRenderFns } from "./WaterMark.vue?vue&type=template&id=58aa1f17"
import script from "./WaterMark.vue?vue&type=script&lang=js"
export * from "./WaterMark.vue?vue&type=script&lang=js"
import style0 from "./WaterMark.vue?vue&type=style&index=0&id=58aa1f17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports